import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
import validationHelpers from '@/mixins/validationHelpers.js'
import {
  requireBigAlpha,
  requireSmallAlpha,
  requireNum,
  onlyAlphaAndSpecSymbols,
} from '@/mixins/customValidators.js'

export default {
  mixins: [validationHelpers],
  computed: {
    fields() {
      return [
        {
          key: 'name',
          component: 'UiInputText',
          attrs: {
            placeholder: 'Имя',
            type: 'text',
          },
          listeners: {
            input: () => this.delayTouch(this.$v.form.name, 'name'),
          },
        },
        {
          key: 'surname',
          component: 'UiInputText',
          attrs: {
            placeholder: 'Фамилия',
            type: 'text',
          },
          listeners: {
            input: () => this.delayTouch(this.$v.form.surname, 'surname'),
          },
        },
        {
          key: 'email',
          component: 'UiInputText',
          attrs: {
            placeholder: 'Почта',
            type: 'email',
            inputmode: 'email',
          },
          listeners: {
            input: () => this.delayTouch(this.$v.form.email, 'email'),
          },
        },
        {
          key: 'phone',
          component: 'UiInputText',
          attrs: {
            placeholder: 'Телефон',
            type: 'tel',
            inputmode: 'tel',
            maska: '+###########',
          },
          listeners: {
            input: () => this.delayTouch(this.$v.form.phone, 'phone'),
          },
        },
        {
          key: 'password',
          component: 'UiInputText',
          attrs: {
            placeholder: 'Пароль',
            type: 'password',
            'password-reveal': true,
          },
          listeners: {
            input: () => this.delayTouch(this.$v.form.password, 'password'),
          },
        },
        {
          key: 'password_confirmation',
          component: 'UiInputText',
          attrs: {
            placeholder: 'Повторите пароль',
            type: 'password',
            'password-reveal': true,
          },
          listeners: {
            input: () =>
              this.delayTouch(this.$v.form.password_confirmation, 'password_confirmation'),
          },
        },
      ]
    },
  },
  validations: {
    form: {
      name: {
        required,
      },
      surname: {
        required,
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
      },
      password: {
        required,
        minLength: minLength(8),
        requireBigAlpha,
        requireSmallAlpha,
        requireNum,
        onlyAlphaAndSpecSymbols,
      },
      password_confirmation: {
        required,
        sameAs: sameAs('password'),
      },
    },
  },
}
